import { render, staticRenderFns } from "./Scans.vue?vue&type=template&id=6bc88403&"
import script from "./Scans.vue?vue&type=script&lang=js&"
export * from "./Scans.vue?vue&type=script&lang=js&"
import style0 from "./Scans.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports